import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../../Api/Api";
import { Loader } from "../../Global/Loader";

import Header from "../../Global/Header";
import ItemWebinar from "./itemWebinar";

const MyWebinars = (props) => {
  const [state, setState] = useState({
    data: [],
    loader: true,
  });

  useEffect(() => {

    base_url
      .get(`webinars`,)
      .then((response) => {
        console.log(response, "webinars");
        setState({
          ...state,
          data: response.data.webinars,
          loader: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <div className="instructpg my-webinars">
      <Loader active={state.loader} />
      <Header innerPage={true} title={"وبینار های من"} />
      <div className="body-webinar">
        {state.data.map((item) => (
          <ItemWebinar data={item} />
        ))}
      </div>
    </div>
  );
};

export default MyWebinars;
